import instance from '../utils/axios';
import _ from 'lodash';

class FieldDescriptionService {

    async getSearchParam(tableName) {
        let result = await instance.post("/crm/common/html/Generate", {tableName: tableName});
        let searchParams = {};
        _.each(eval("(" + result.data + ")"), function (item) {
            searchParams["searchField_" + item.type + "_" + item.field] = "";
        });
        return searchParams;
    }

    async getFieldDisplayOnAPP(tableName) {
        return await instance.post("/crm/systemConfig/fieldDescription/getDisplayToAppFields", {tableName: tableName});
    }

    async getDictionaryName(tableName) {
        return await instance.post("/crm/systemConfig/fieldDescription/getDictionaryName", {tableName: tableName});
    }

    async getGridDescription(deMetaId) {
        return await instance.get(`/crm/field/description/grid?deMetaId=${deMetaId}`);
    }
	async getGridByTableName(tableName) {
	    return await instance.get(`/crm/field/description/grid/byTableName/?tableName=${tableName}`);
	}
}

export default new FieldDescriptionService();